import { RecipientName } from '../../../containers/orders-filter-bar-container/filter-options/options/recipient-name';
import { Tag } from '../../../containers/orders-filter-bar-container/filter-options/options/tag';
import { BuyerName } from '../../../containers/orders-filter-bar-container/filter-options/options/buyer-name';
import { AddressLine1 } from '../../../containers/orders-filter-bar-container/filter-options/options/address-line-1';
import { AddressLine2 } from '../../../containers/orders-filter-bar-container/filter-options/options/address-line-2';
import { BuyerId } from '../../../containers/orders-filter-bar-container/filter-options/options/buyer-id';
import { City } from '../../../containers/orders-filter-bar-container/filter-options/options/city';
import { CustomField1 } from '../../../containers/orders-filter-bar-container/filter-options/options/custom-field-1';
import { CustomField2 } from '../../../containers/orders-filter-bar-container/filter-options/options/custom-field-2';
import { CustomField3 } from '../../../containers/orders-filter-bar-container/filter-options/options/custom-field-3';
import { InternalNotes } from '../../../containers/orders-filter-bar-container/filter-options/options/internal-notes';
import { ItemName } from '../../../containers/orders-filter-bar-container/filter-options/options/item-name';
import { ItemSku } from '../../../containers/orders-filter-bar-container/filter-options/options/item-sku';
import { NotesToBuyer } from '../../../containers/orders-filter-bar-container/filter-options/options/notes-to-buyer';
import { NotesFromBuyer } from '../../../containers/orders-filter-bar-container/filter-options/options/notes-from-buyer';
import { OrderNumber } from '../../../containers/orders-filter-bar-container/filter-options/options/order-number';
import { PostalCode } from '../../../containers/orders-filter-bar-container/filter-options/options/postal-code';
import { Zone } from '../../../containers/orders-filter-bar-container/filter-options/options/zone';
import { AddressValidationStatus } from '../../../containers/orders-filter-bar-container/filter-options/options/address-validation-status';
import { AssignedTo } from '../../../containers/orders-filter-bar-container/filter-options/options/assigned-to';
import { LineItems } from '../../../containers/orders-filter-bar-container/filter-options/options/line-items';
import { AmountPaid } from '../../../containers/orders-filter-bar-container/filter-options/options/amount-paid';
import { OrderSubtotal } from '../../../containers/orders-filter-bar-container/filter-options/options/order-subtotal';
import { OrderTotal } from '../../../containers/orders-filter-bar-container/filter-options/options/order-total';
import { ShippingPaid } from '../../../containers/orders-filter-bar-container/filter-options/options/shipping-paid';
import { TaxPaid } from '../../../containers/orders-filter-bar-container/filter-options/options/tax-paid';
import { Quantity } from '../../../containers/orders-filter-bar-container/filter-options/options/quantity';
import { Carrier } from '../../../containers/orders-filter-bar-container/filter-options/options/carrier';
import { Marketplace } from '../../../containers/orders-filter-bar-container/filter-options/options/marketplace';
import { RequestedServiceMarketplace } from '../../../containers/orders-filter-bar-container/filter-options/options/requested-service-marketplace';
import { Store } from '../../../containers/orders-filter-bar-container/filter-options/options/store';
import { ShipFrom } from '../../../containers/orders-filter-bar-container/filter-options/options/ship-from';
import { DatePaid } from '../../../containers/orders-filter-bar-container/filter-options/options/date-paid';
import { ShipByDate } from '../../../containers/orders-filter-bar-container/filter-options/options/ship-by-date';
import { OrderDate } from '../../../containers/orders-filter-bar-container/filter-options/options/order-date';
import { Warehouse } from '../../../containers/orders-filter-bar-container/filter-options/options/warehouse';
import { Source } from '../../../containers/orders-filter-bar-container/filter-options/options/source';
import { Country } from '../../../containers/orders-filter-bar-container/filter-options/options/country';
import { Gift } from '../../../containers/orders-filter-bar-container/filter-options/options/gift';
import { International } from '../../../containers/orders-filter-bar-container/filter-options/options/filter-editor/international';
import { RecipientCompany } from '../../../containers/orders-filter-bar-container/filter-options/options/filter-editor/recipient-company';
import { State } from '../../../containers/orders-filter-bar-container/filter-options/options/state';
import { ResidentialIndicator } from '../../../containers/orders-filter-bar-container/filter-options/options/filter-editor/residential-indicator';
import { PackageType } from '../../../containers/orders-filter-bar-container/filter-options/options/package-type';
import { ShippingAccount } from '../../../containers/orders-filter-bar-container/filter-options/options/shipping-account/shipping-account';
import { BillToParty } from '../../../containers/orders-filter-bar-container/filter-options/options/filter-editor/bill-to-party';
import { Weight } from '../../../containers/orders-filter-bar-container/filter-options/options/weight';
import { RequestedServiceMapped } from '../../../containers/orders-filter-bar-container/filter-options/options/requested-service-mapped';
import { PaymentMethod } from '../../../containers/orders-filter-bar-container/filter-options/options/payment-method';
import { SellerBrand } from '../../../containers/orders-filter-bar-container/filter-options/options/seller-brand';
import { FulfillmentProvider } from '../../../containers/orders-filter-bar-container/filter-options/options/fulfillment-provider';
import { DeliverByDate } from '../../../containers/orders-filter-bar-container/filter-options/options/deliver-by-date';
import { ShopifyShipFrom } from '../../../containers/orders-filter-bar-container/filter-options/options/shopify-ship-from';
import { OrderImportTime } from '../../../containers/orders-filter-bar-container/filter-options/options/order-import-time';

import {
  EDITOR_TYPE_UNDEFINED,
  EDITOR_TYPE_BUYER_NAME,
  EDITOR_TYPE_ORDER_TAGS,
  EDITOR_TYPE_RECIPIENT_NAME,
  EDITOR_TYPE_ADDRESS_LINE_1,
  EDITOR_TYPE_ADDRESS_LINE_2,
  EDITOR_TYPE_BUYER_ID,
  EDITOR_TYPE_CITY,
  EDITOR_TYPE_CUSTOM_FIELD_1,
  EDITOR_TYPE_CUSTOM_FIELD_2,
  EDITOR_TYPE_CUSTOM_FIELD_3,
  EDITOR_TYPE_INTERNAL_NOTES,
  EDITOR_TYPE_ITEM_NAME,
  EDITOR_TYPE_ITEM_SKU,
  EDITOR_TYPE_NOTES_TO_BUYER,
  EDITOR_TYPE_NOTES_FROM_BUYER,
  EDITOR_TYPE_ORDER_NUMBER,
  EDITOR_TYPE_POSTAL_CODE,
  EDITOR_TYPE_RECIPIENT_COMPANY,
  EDITOR_TYPE_ORDER_SOURCE,
  EDITOR_TYPE_USPS_ZONE,
  EDITOR_TYPE_ADDRESS_VERIFICATION,
  EDITOR_TYPE_ASSIGNED_USER,
  EDITOR_TYPE_LINE_ITEMS,
  EDITOR_TYPE_AMOUNT_PAID,
  EDITOR_TYPE_ORDER_SUBTOTAL,
  EDITOR_TYPE_ORDER_TOTAL,
  EDITOR_TYPE_SHIPPING_PAID,
  EDITOR_TYPE_TAX_PAID,
  EDITOR_TYPE_TOTAL_QUANTITY,
  EDITOR_TYPE_CARRIER,
  EDITOR_TYPE_MARKETPLACE,
  EDITOR_TYPE_REQUESTED_SERVICE_UNMAPPED,
  EDITOR_TYPE_STORE,
  EDITOR_TYPE_SHIP_FROM,
  EDITOR_TYPE_SHOPIFY_SHIP_FROM,
  EDITOR_TYPE_DATE_PAID,
  EDITOR_TYPE_SHIP_BY_DATE,
  EDITOR_TYPE_ORDER_DATE,
  EDITOR_TYPE_WAREHOUSE_LOCATION,
  EDITOR_TYPE_SHIP_TO_COUNTRY,
  EDITOR_TYPE_IS_GIFT,
  EDITOR_TYPE_IS_INTERNATIONAL,
  EDITOR_TYPE_STATE,
  EDITOR_TYPE_RESIDENTIAL_INDICATOR,
  EDITOR_TYPE_PACKAGE_TYPE,
  EDITOR_TYPE_SHIPPING_ACCOUNT,
  EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT,
  EDITOR_TYPE_ORDER_WEIGHT,
  EDITOR_TYPE_REQUESTED_SERVICE_MAPPED,
  EDITOR_TYPE_PAYMENT_METHOD,
  EDITOR_TYPE_SELLER_BRAND,
  EDITOR_TYPE_FULFILLMENT_PROVIDER,
  EDITOR_TYPE_DELIVER_BY_DATE,
  EDITOR_TYPE_ORDER_IMPORT_TIME,
} from '../constants/filter-editor-type';

const filterColumnNameFromEditorTypeMap = {
  [EDITOR_TYPE_BUYER_NAME]: BuyerName.filterValue,
  [EDITOR_TYPE_ORDER_TAGS]: Tag.filterValue,
  [EDITOR_TYPE_RECIPIENT_NAME]: RecipientName.filterValue,
  [EDITOR_TYPE_ADDRESS_LINE_1]: AddressLine1.filterValue,
  [EDITOR_TYPE_ADDRESS_LINE_2]: AddressLine2.filterValue,
  [EDITOR_TYPE_BUYER_ID]: BuyerId.filterValue,
  [EDITOR_TYPE_CITY]: City.filterValue,
  [EDITOR_TYPE_CUSTOM_FIELD_1]: CustomField1.filterValue,
  [EDITOR_TYPE_CUSTOM_FIELD_2]: CustomField2.filterValue,
  [EDITOR_TYPE_CUSTOM_FIELD_3]: CustomField3.filterValue,
  [EDITOR_TYPE_INTERNAL_NOTES]: InternalNotes.filterValue,
  [EDITOR_TYPE_ITEM_NAME]: ItemName.filterValue,
  [EDITOR_TYPE_ITEM_SKU]: ItemSku.filterValue,
  [EDITOR_TYPE_NOTES_TO_BUYER]: NotesToBuyer.filterValue,
  [EDITOR_TYPE_NOTES_FROM_BUYER]: NotesFromBuyer.filterValue,
  [EDITOR_TYPE_ORDER_NUMBER]: OrderNumber.filterValue,
  [EDITOR_TYPE_POSTAL_CODE]: PostalCode.filterValue,
  [EDITOR_TYPE_USPS_ZONE]: Zone.filterValue,
  [EDITOR_TYPE_ADDRESS_VERIFICATION]: AddressValidationStatus.filterValue,
  [EDITOR_TYPE_ASSIGNED_USER]: AssignedTo.filterValue,
  [EDITOR_TYPE_LINE_ITEMS]: LineItems.filterValue,
  [EDITOR_TYPE_AMOUNT_PAID]: AmountPaid.filterValue,
  [EDITOR_TYPE_ORDER_SUBTOTAL]: OrderSubtotal.filterValue,
  [EDITOR_TYPE_ORDER_TOTAL]: OrderTotal.filterValue,
  [EDITOR_TYPE_SHIPPING_PAID]: ShippingPaid.filterValue,
  [EDITOR_TYPE_TAX_PAID]: TaxPaid.filterValue,
  [EDITOR_TYPE_TOTAL_QUANTITY]: Quantity.filterValue,
  [EDITOR_TYPE_CARRIER]: Carrier.filterValue,
  [EDITOR_TYPE_MARKETPLACE]: Marketplace.filterValue,
  [EDITOR_TYPE_REQUESTED_SERVICE_UNMAPPED]: RequestedServiceMarketplace.filterValue,
  [EDITOR_TYPE_STORE]: Store.filterValue,
  [EDITOR_TYPE_SHIP_FROM]: ShipFrom.filterValue,
  [EDITOR_TYPE_SHOPIFY_SHIP_FROM]: ShopifyShipFrom.filterValue,
  [EDITOR_TYPE_DATE_PAID]: DatePaid.filterValue,
  [EDITOR_TYPE_SHIP_BY_DATE]: ShipByDate.filterValue,
  [EDITOR_TYPE_ORDER_DATE]: OrderDate.filterValue,
  [EDITOR_TYPE_WAREHOUSE_LOCATION]: Warehouse.filterValue,
  [EDITOR_TYPE_ORDER_SOURCE]: Source.filterValue,
  [EDITOR_TYPE_SHIP_TO_COUNTRY]: Country.filterValue,
  [EDITOR_TYPE_IS_GIFT]: Gift.filterValue,
  [EDITOR_TYPE_IS_INTERNATIONAL]: International.filterValue,
  [EDITOR_TYPE_RECIPIENT_COMPANY]: RecipientCompany.filterValue,
  [EDITOR_TYPE_STATE]: State.filterValue,
  [EDITOR_TYPE_RESIDENTIAL_INDICATOR]: ResidentialIndicator.filterValue,
  [EDITOR_TYPE_PACKAGE_TYPE]: PackageType.filterValue,
  [EDITOR_TYPE_SHIPPING_ACCOUNT]: ShippingAccount.filterValue,
  [EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT]: BillToParty.filterValue,
  [EDITOR_TYPE_ORDER_WEIGHT]: Weight.filterValue,
  [EDITOR_TYPE_REQUESTED_SERVICE_MAPPED]: RequestedServiceMapped.filterValue,
  [EDITOR_TYPE_PAYMENT_METHOD]: PaymentMethod.filterValue,
  [EDITOR_TYPE_SELLER_BRAND]: SellerBrand.filterValue,
  [EDITOR_TYPE_FULFILLMENT_PROVIDER]: FulfillmentProvider().filterValue,
  [EDITOR_TYPE_DELIVER_BY_DATE]: DeliverByDate.filterValue,
  [EDITOR_TYPE_ORDER_IMPORT_TIME]: OrderImportTime.filterValue,
};

export const filterColumnNameFromEditorType = (editorType = EDITOR_TYPE_UNDEFINED) => {
  return filterColumnNameFromEditorTypeMap[editorType];
};
